import { getSelectedYear } from 'app/slices/GamesSlice';
import { store } from 'app/store';
import { Cls, Emo } from 'app/constants';
import { SeasonID } from 'types';

export type ComparisonLoaderPayload = {
  yearID: SeasonID;
};

/**
 * Loader for Comparison route - extracts year from URL params.
 *
 * @param {any} params - Route parameters
 * @return {Promise<ComparisonLoaderPayload | Response>} Loader payload
 */
export const comparisonLoader = async ({ params }: any): Promise<ComparisonLoaderPayload | Response> => {
  const msg = `params.yearId %c ${params.yearId} %c`;

  console.log(`${Emo.eyes} %c comparisonLoader %c ${msg}`, Cls.Loc, '', Cls.Val, '');
  const yearID = (params.yearId ?? getSelectedYear(store.getState())) as SeasonID;

  return {
    yearID,
  };
};
